import type { TripListResponse } from "../../types/operations/tripList.type";

export const mockTripList = {
  default: {
    summary: {
      today: { trips: 4, bills: 52, weight: 43500 },
      tomorrow: { trips: 1, bills: 8, weight: 6200 },
      enRoute: { trips: 2, bills: 30, weight: 25000 },
      checkedIn: { trips: 2, bills: 22, weight: 18500 },
      closingSoon: { trips: 1, bills: 15, weight: 13834 },
    },
    trips: [
      {
        bookingNumber: "39485743",
        tripNumber: 2940391,
        loadingDate: "2026-04-01",
        hasCheckedIn: true,
        trailerNumber: "DYLT170381",
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 114,
        destinationSicCode: "EWR",
        stopSicId: null,
        stopSicCode: null,
        estimatedCloseTimeUtc: "2026-03-27T10:00:00Z",
        actualCloseTimeUtc: null,
        arrivalEtaUtc: "2026-03-27T10:00:00Z",
        bills: 5,
        cube: 89,
        pallets: 1,
        pieces: 0,
        handlingUnits: 4,
        weight: 432,
        carrier: { name: "C R ENGLAND INC" },
        dotNumber: null,
        mcNumber: null,
        status: { id: 22, name: "LDDK" as const },
        currentLocation: { title: "Door 007", subtext: "ONT" },
        closeSoon: false,
        pastCloseTime: true,
        driverCheckIn: null,
      },
      {
        bookingNumber: "39485743",
        tripNumber: 2940391,
        loadingDate: "2026-04-01",
        hasCheckedIn: true,
        trailerNumber: "DYLT170381",
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 114,
        destinationSicCode: "EWR",
        stopSicId: null,
        stopSicCode: null,
        estimatedCloseTimeUtc: "2026-03-27T10:00:00Z",
        actualCloseTimeUtc: "2026-03-27T10:00:00Z",
        arrivalEtaUtc: "2026-03-27T10:00:00Z",
        bills: 5,
        cube: 89,
        pallets: 1,
        pieces: 0,
        handlingUnits: 4,
        weight: 432,
        carrier: { name: "C R ENGLAND INC" },
        dotNumber: null,
        mcNumber: null,
        status: { id: 26, name: "ENRT" as const },
        currentLocation: { title: "I-10W", subtext: "Fontana" },
        closeSoon: false,
        pastCloseTime: false,
        driverCheckIn: {
          checkedInTimeUtc: "2026-03-27T08:15:00",
          checkInUserName: null,
          tractorNumber: "555",
          emptyTrailerDrop: true,
          carrierId: null,
          trailerNumber: "111",
          equipmentId: null,
          driver1: {
            id: 66121,
            driverId: 0,
            driverName: "BASILO JESUS PEREZ",
            phoneNumber: "817-435-3846",
            licenseNumber: null,
            licenseState: "TX",
          },
          driver2: null,
        },
      },
      {
        bookingNumber: "88965478",
        tripNumber: 10024384,
        loadingDate: "2026-04-01",
        hasCheckedIn: false,
        trailerNumber: "DYLT170382",
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 114,
        destinationSicCode: "EWR",
        stopSicId: 112,
        stopSicCode: "HTX",
        estimatedCloseTimeUtc: "2026-03-27T10:00:00Z",
        actualCloseTimeUtc: null,
        arrivalEtaUtc: null,
        bills: 5,
        cube: 89,
        hlCube: 28,
        pallets: 1,
        pieces: 0,
        handlingUnits: 4,
        weight: 432,
        carrier: { name: "WERNER ENTERPRISES" },
        dotNumber: null,
        mcNumber: null,
        status: { id: 20, name: "PLAN" as const },
        currentLocation: { title: "At origin", subtext: null },
        closeSoon: false,
        pastCloseTime: false,
        driverCheckIn: null,
      },
      {
        bookingNumber: "39485743",
        tripNumber: 2940391,
        loadingDate: "2026-04-01",
        hasCheckedIn: false,
        trailerNumber: "DYLT170383",
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 114,
        destinationSicCode: "EWR",
        stopSicId: null,
        stopSicCode: null,
        estimatedCloseTimeUtc: "2026-03-27T10:00:00Z",
        actualCloseTimeUtc: null,
        arrivalEtaUtc: null,
        bills: 5,
        cube: 89,
        pallets: 1,
        pieces: 0,
        handlingUnits: 4,
        weight: 432,
        carrier: { name: "C R ENGLAND INC" },
        dotNumber: null,
        mcNumber: null,
        status: { id: 22, name: "LDDK" as const },
        currentLocation: { title: "Door 010", subtext: "ONT" },
        closeSoon: false,
        pastCloseTime: true,
        driverCheckIn: null,
      },
    ],
  },
} satisfies Record<string, TripListResponse>;
